import { render } from "./woniuBill.vue?vue&type=template&id=161b33fe&scoped=true"
import script from "./woniuBill.vue?vue&type=script&lang=js"
export * from "./woniuBill.vue?vue&type=script&lang=js"

import "./woniuBill.vue?vue&type=style&index=0&id=161b33fe&scoped=true&lang=css"
import "./woniuBill.vue?vue&type=style&index=1&id=161b33fe&lang=css"
script.render = render
script.__scopeId = "data-v-161b33fe"

export default script